import React, { useEffect, useState } from 'react'
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton'

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './NewOperationalArea.module.css';
import { ControlFunctionServiceApi, OperationalScopeServicesApi } from '../../service';
import Loading from '../../components/Loading/Loading';
import GenericModal from '../../UI/GenericModal';
import { useHistory } from 'react-router-dom';
import { isSuperuserValue } from '../../access/access';

const NewOperationalArea = () => {
  const [controlFunctions, setControlFunctions] = useState([]);
  const [opScopeName, setOpScopeName] = useState("");
  const [opScopeTooltip, setOpScopeTooltip] = useState("");
  const [isActiveScope, setIsActiveScope] = useState(true);
  const [isLoading, setIsLoading] = useState();

  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();
  console.log("controlFunctions: ", controlFunctions);
  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setIsLoading(true);

    const controlFunctionServiceApi = new ControlFunctionServiceApi();
    controlFunctionServiceApi.getAllControlFunctions((error, data) => {
      console.log("API control functions: ", data);

      if (mounted) {
        if (!error) {
          setControlFunctions(data.map((item) => {
            return {
              id: item.id,
              name: item.name,
              value: false
            }
          })
          .sort( (a,b) => a.id > b.id ? 1 : -1));
          setIsLoading(false);
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }
    });
    return (() => {
      mounted = false;
    })
  },[]);

  const opScopeNameHandler = (value) => {
    setOpScopeName(value);
  }

  const opScopeTooltipHandler = (value) => {
    setOpScopeTooltip(value);
  }

  const updateControlFunctionValue = (id, value) => {
    const newControlFunctionValues = [...controlFunctions];
    for (const el of newControlFunctionValues) {
      if (el.id === id) {
        el.value = value;
        break;
      }
    }
    setControlFunctions(newControlFunctionValues);
  }

  const updateActiveScopeValue = (value) => {
    console.log("Active value: ", value);
    setIsActiveScope(value);
  }

  const submitFormHandler = () => {
    console.log("Submit function")
    
    if (validValues()) {
      setIsLoading(true);
      const requestBody = {
        name: opScopeName,
        tooltip: opScopeTooltip,
        active: isActiveScope,
        controlFunctionIds: controlFunctions.filter(el => el.value === true).map(el => el.id)
      }
      
      console.log("requestBody: ", requestBody);
      const operationalScopeServicesApi = new OperationalScopeServicesApi();
      operationalScopeServicesApi.newOperationalScope(requestBody/*"invalid value"*/, (error, data) => {
        if (!error) {
          setIsLoading(false);
          modalDataHandler("", `The operational scope "${opScopeName}" was created`, 'notification', () => history.push("/operational-area-monitor"))  
        } else {
          setIsLoading(false);
          modalDataHandler("", `An error ocurred. A new operational scope could not be created!`, 'notification', () => history.push("/operational-area-monitor"))
          // throw new Error(error.message)  
        }
      })
    } else {
       modalDataHandler("", `The operational area must have a name and at least one control function must be selected`, 'notification', modalCloseHandler)
    }
  }

  const validValues = () => {
    let activeCFunctions = controlFunctions.filter(el => el.value === true);
    if (activeCFunctions.length === 0 || opScopeName.length === 0) {
      return false;
    } else {
      return true;
    }
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const requestBody = {
    name: opScopeName,
    active: isActiveScope,
    controlFunctionIds: controlFunctions.filter(el => el.value === true).map(el => el.id)
  }

  // console.log("requestBody: ", requestBody);

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      modalDataHandler(
        "Add Operational Area",
        "Add new operational area?",
        'confirmation',
        submitFormHandler
      )}}>
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      <div className="d-flex justify-content-between mt-2">
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1" htmlFor="new-operational-scope">
            Operational Scope Name
          </label>
          <input
            className={styles.textInput}
            type="text"
            onChange={(e) => {
              opScopeNameHandler(e.target.value);
            }}
            placeholder="Type the new operational scope"
          />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="active" className="mb-1 fw-bold">
            Active
          </label>
          <input
            type="checkbox"
            id="active"
            className={styles.activeCheckbox}
            name="activeValue"
            checked={isActiveScope}
            onChange={(e) => {
              updateActiveScopeValue(e.target.checked)
            }}
          />
        </div>
        <div>
          <img src={nexiLogo} className={`${styles.logo}`} alt="nexi-group" />
        </div>
      </div>
      <div className="d-flex flex-column mt-2">
        <label className="fw-bold mb-1 ms-1">
          Description
        </label>
        <input
          className={`${styles.textInput} ${styles.tooltip}`}
          value={opScopeTooltip ? opScopeTooltip : ""}
          type="text"
          onChange={(e) => {
            opScopeTooltipHandler(e.target.value);
          }}
          placeholder="Type a new description"
          />
      </div>
      <p className="fw-bold mb-1 mt-4 ms-1">Scope</p>
      <div className="hr position-relative">
      </div>
      {isLoading && <Loading height={"82px"} />}
      {!isLoading && (
        <div
          style={{ maxWidth: "580px" }}
          className="d-flex justify-content-between mt-2 me-2"
        >
          <label className="fst-italic ms-1">Control functions:</label>
          {controlFunctions.map((item) => (
            <div key={item.id}>
              <input
                type="checkbox"
                id={item.id}
                onChange={(e) => {
                  updateControlFunctionValue(item.id, e.target.checked);
                }}
                name="control-functions"
              />
              <label htmlFor={item.id} className="ms-2 fw-bold">
                {item.name}
              </label>
            </div>
          ))}
        </div>
      )}
      {!isLoading && <SubmitButton
        type="submit"
        disabled={!validValues()}
        class={`${styles.submitButton} mt-3 mb-1 me-3 float-end`}
      >Add</SubmitButton>}
    </form>
  );
}

export default NewOperationalArea;
